import React,{ useState } from 'react';
import Modal from 'react-bootstrap/Modal';

const SubEditor = (props) => {
    const [ modalShow, modalToggler ] = useState(false);
    const sub_editor = props.sub_editor.map(( data ) => ( data.fname + " " + data.lname ));
    // console.log( sub_author ); 
    return (
        <div className='sub_author_main_container'>
            <div className='sub_author_list'>
                {
                    sub_editor.map( ( data, index ) => (<div key={ index } className='sub_author'>{ data }</div>) )
                }
            </div>
            <div className='add_author' onClick={ () => modalToggler( true ) }>Add editors</div>
            <Modal show={ modalShow } size='md' onHide={ () => modalToggler(false) } >
                <Modal.Body>
                    <SubEditorList onClose={ () => modalToggler( false ) } {...props} />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default SubEditor;
// sub_author_list
export const SubEditorList = (props) =>{
    return (
        <div className='sub_author_list_main_container'>
            <div className='assign_publication_label'>Select Sub Editor</div>
                <div className='publication_assign_container'>
                    {
                        props.sub_author_list.map( ( data, index ) => (
                            <div key={ index } className='publication_data_container'>
                                <div className='publication_label'>{ data.fname+" "+data.lname }&nbsp;{ `(${ data.email })` }</div>
                                <div className='publication_input'><input onChange={ props.onSubEditorHandler( data ) } checked={ ( props.isSubEditorPresent( data ) || props.isSubEditorPresent(data) === 0  ) ? true : false  }   type='checkbox' /></div>
                            </div>
                        ) )
                    }
                </div>
                <div className='button_container'>
                <button className='button_yellow' onClick={ props.onClose }>Close</button>
            </div>
        </div>
    )
}
